module.exports = __webpack_public_path__ + "img/sm.9bdbff1.svg";